<template>
  <aside class="col-12 col-md-3 py-4">
    <img class="mw-100" v-bind:src="'/assets/images/products/' + image" />
  </aside>
</template>

<script>

export default {
  name: 'StoCscResultItemAside',
  props: {
    image: String
  }
}

</script>
<style>
  img {
    max-height: 400px;
  }
</style>
